export const getSkinConfig = state => {
  return state.skinConfig;
};

export const getTimelineSkinConfig = state => {
  return state.timelineSkinConfig;
};